const StarRating = ({ rating, size = 20, color = "#FFD700" }) => {
    const maxStars = 5;

    return (
        <div style={{ display: "flex", gap: "2px", justifyContent: "center", marginTop: "5px" }}>
            {[...Array(maxStars)].map((_, index) => (
                <span key={index} style={{ fontSize: `${size}px`, color: index < rating ? color : "#ccc" }}>
          {index < rating ? "★" : "☆"}
        </span>
            ))}
        </div>
    );
};

export default StarRating;
